


















































































import { Component, Vue } from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import userApi from "@/api/userApi";
import { namespace } from "vuex-class";
import { ADMIN_TYPE, CUSTOMER_TYPE } from "@/common/constant";
import _cloneDeep from "lodash/cloneDeep";
import { compareWithKeys } from "@/common/utils";
const auth = namespace("Auth");
const HIDE_PASSWORD_CHARACTER = "************";

@Component({
  name: "ChangeUserInfo",
  components: {
    QErrors,
  },
})
export default class ForgotPassword extends Vue {
  @auth.Action
  fetchCurrentUser!: (user: any) => void;
  @auth.Getter
  getUserType;
  @auth.Getter
  getUserLogging;
  public errors = {};
  public isShow = false;
  public form = {
    name: "",
    mail_address: "",
    login_id: "",
    login_password: "",
    is_changed_password_field: false,
  };
  public formInit = {
    name: "",
    mail_address: "",
    login_id: "",
    login_password: "",
    is_changed_password_field: false,
  };
  get isCustomer() {
    return this.getUserType == CUSTOMER_TYPE;
  }
  public errorMessage = "";
  public show() {
    this.form = {
      name:
        this.getUserType == ADMIN_TYPE
          ? this.getUserLogging.administrator_name
          : this.getUserLogging.account_supervisor_name,
      mail_address:
        this.getUserType == CUSTOMER_TYPE
          ? this.getUserLogging.mail_address
          : "",
      login_id: this.getUserLogging.login_id,
      login_password: HIDE_PASSWORD_CHARACTER,
      is_changed_password_field: false,
    };
    this.errors = {};
    this.isShow = true;
    this.formInit = _cloneDeep(this.form);
  }

  get needDisable() {
    return this.isCustomer && this.getUserLogging.is_changed_password == false;
  }

  async updateUserInfo() {
    try {
      this.errors = {};

      if (!this.form.is_changed_password_field) {
        this.errors = {
          login_password: {
            0: this.$t("common.message.not_change_password"),
          },
        };
        return;
      }

      const response = await userApi.updateUserInfo(this.form);
      if (response.data.meta.status == 200) {
        await this.fetchCurrentUser(response.data.data.user_info);
        if (
          !this.isCustomer ||
          response.data.data.user_info.is_changed_password == true
        ) {
          this.isShow = false;
          this.$emit("close");
        }
      } else if (response.data.meta.status == 422) {
        this.errors = response.data.meta.errors;
      } else {
        qNotify.error({
          text: this.$t(response.data.meta.message),
        });
      }
    } catch (error) {
      if (error.response) {
        qNotify.error({
          text: this.$t(error.response.data.meta.message),
        });
      } else {
        console.log(error);
      }
    }
  }

  public handleChangePassword(event) {
    if (!this.form.is_changed_password_field) {
      this.form.is_changed_password_field = true;
      this.form.login_password = event.data;
    }
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.cancel_message", {
          name: this.form.name,
        })}`,
        confirmText: `${this.$t("common.message.cancel_button")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public isChanged() {
    if (this.isCustomer) {
      return compareWithKeys(this.form, this.formInit, [
        "name",
        "mail_address",
        "login_id",
        "login_password",
      ]);
    } else {
      return compareWithKeys(this.form, this.formInit, [
        "name",
        "login_id",
        "login_password",
      ]);
    }
  }
}
